var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('EChart',{attrs:{"loading":_vm.loading,"height":_vm.percentilesChart.height,"option":_vm.percentilesChart.option,"group":_vm.internalGroup}}),_c('EChart',{attrs:{"loading":_vm.loading,"height":_vm.rateChart.height,"option":_vm.rateChart.option,"group":_vm.internalGroup,"annotations":_vm.annotations}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }